(function () {
  'use strict';

  var GLOBAL_KEY = '__centauriC31DetailGallery';

  if (window[GLOBAL_KEY] && window[GLOBAL_KEY].init) {
    window[GLOBAL_KEY].init(document);
    return;
  }

  var ROOT_SELECTOR = '[data-c31-gallery]';
  var ITEM_SELECTOR = '[data-c31-item]';
  var GROUP_SELECTOR = '[data-c31-group]';
  /* group_cycle repeats three collage patterns (Figma 4238-108647/108654/108710):
     A = 3 images, B = 1 tall image, C = 4 images. 8 images per full cycle. */
  var PATTERNS = [
    { key: 'a', size: 3 },
    { key: 'b', size: 1 },
    { key: 'c', size: 4 }
  ];
  var states = new WeakMap();

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function layoutFor(root) {
    return root && root.dataset && root.dataset.c31Layout ? root.dataset.c31Layout : 'two_rows_asymmetric';
  }

  function isGroupCycle(root) {
    return layoutFor(root) === 'group_cycle';
  }

  function groupSize(root) {
    var layout = layoutFor(root);
    if (layout === 'one_col_one_row') return 1;
    if (layout === 'one_col_two_rows') return 2;
    return 4;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function itemsFor(root) {
    return toArray(root.querySelectorAll(ITEM_SELECTOR));
  }

  function groupsFor(root) {
    return toArray(root.querySelectorAll(GROUP_SELECTOR));
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function setButton(button, other, disabled) {
    if (!button) return;
    if (disabled && !button.disabled && document.activeElement === button && other && !other.disabled) {
      other.focus();
    }
    button.disabled = disabled;
    button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  }

  /* ---------------------------------------------------------------- */
  /* Legacy paging (two_rows_asymmetric / one_col_two_rows / one_col_one_row) */

  function render(state, preferredIndex) {
    var items = itemsFor(state.root);
    var size = groupSize(state.root);
    var total = Math.ceil(items.length / size);
    var page;

    if (typeof preferredIndex === 'number') {
      page = Math.floor(preferredIndex / size);
    } else if (state.size && state.size !== size) {
      page = Math.floor((state.page * state.size) / size);
    } else {
      page = state.page || 0;
    }

    page = clamp(page, 0, Math.max(total - 1, 0));
    state.page = page;
    state.size = size;

    var start = total > 0 ? page * size : 0;
    var end = start + size;

    for (var i = 0; i < items.length; i += 1) {
      var hidden = i < start || i >= end;
      items[i].hidden = hidden;
      items[i].setAttribute('aria-hidden', hidden ? 'true' : 'false');
      if (hidden) {
        items[i].removeAttribute('data-c31-slot');
      } else {
        items[i].setAttribute('data-c31-slot', String(i - start + 1));
      }
    }

    if (state.controls) state.controls.hidden = total <= 1;
    setButton(state.prev, state.next, total <= 1 || page === 0);
    setButton(state.next, state.prev, total <= 1 || page >= total - 1);

    if (state.status) {
      state.status.textContent = total > 1 ? 'Image group ' + (page + 1) + ' of ' + total : '';
    }

    state.root.dataset.c31Ready = 'true';
    state.root.dataset.c31ActiveLayout = layoutFor(state.root);
    state.root.dataset.c31CurrentGroup = total > 0 ? String(page + 1) : '0';
    state.root.dataset.c31GroupCount = String(total);
  }

  /* ---------------------------------------------------------------- */
  /* group_cycle: wrap the flat item list into pattern panels on a
     horizontally scrolling track. */

  function unwrapGroups(root) {
    var track = root.querySelector('[data-c31-track]');
    if (!track) return;

    var groups = toArray(track.querySelectorAll(GROUP_SELECTOR));
    for (var i = 0; i < groups.length; i += 1) {
      var group = groups[i];
      var items = toArray(group.querySelectorAll(ITEM_SELECTOR));
      for (var j = 0; j < items.length; j += 1) {
        items[j].removeAttribute('data-c31-slot');
        track.insertBefore(items[j], group);
      }
      track.removeChild(group);
    }

    root.removeAttribute('data-c31-grouped');
  }

  function wrapGroups(root) {
    var track = root.querySelector('[data-c31-track]');
    if (!track) return;

    unwrapGroups(root);

    var items = toArray(track.querySelectorAll(ITEM_SELECTOR));
    if (!items.length) return;

    var cursor = 0;
    var patternIndex = 0;

    while (cursor < items.length) {
      var pattern = PATTERNS[patternIndex % PATTERNS.length];
      var group = document.createElement('li');
      group.className = 'c31-group c31-group--' + pattern.key;
      group.setAttribute('data-c31-group', '');
      group.setAttribute('data-c31-pattern', pattern.key);

      var grid = document.createElement('ul');
      grid.className = 'c31-group__grid';
      grid.setAttribute('role', 'list');
      group.appendChild(grid);

      for (var slot = 0; slot < pattern.size && cursor < items.length; slot += 1) {
        var item = items[cursor];
        item.hidden = false;
        item.removeAttribute('aria-hidden');
        item.setAttribute('data-c31-slot', String(slot + 1));
        grid.appendChild(item);
        cursor += 1;
      }

      track.appendChild(group);
      patternIndex += 1;
    }

    root.dataset.c31Grouped = 'true';
  }

  function groupOffset(state, group) {
    if (!state.track || !group) return 0;
    return group.getBoundingClientRect().left - state.track.getBoundingClientRect().left;
  }

  function currentGroupIndex(state) {
    var groups = groupsFor(state.root);
    var wall = state.wall;
    if (!wall || !groups.length) return 0;
    /* The last group can sit past the maximum scroll offset; when the track is
       scrolled to its end the last group is the one on stage. */
    if (wall.scrollLeft >= wall.scrollWidth - wall.clientWidth - 1) {
      return groups.length - 1;
    }
    var index = 0;
    for (var i = 0; i < groups.length; i += 1) {
      if (groupOffset(state, groups[i]) <= wall.scrollLeft + 2) index = i;
    }
    return index;
  }

  function goToGroup(state, index, behavior) {
    var groups = groupsFor(state.root);
    if (!groups.length || !state.wall) return;

    index = clamp(index, 0, groups.length - 1);
    state.target = index;
    var left = groupOffset(state, groups[index]);
    var mode = behavior || (prefersReducedMotion() ? 'auto' : 'smooth');

    if (typeof state.wall.scrollTo === 'function') {
      state.wall.scrollTo({ left: left, behavior: mode });
    } else {
      state.wall.scrollLeft = left;
    }
  }

  /* Rapid prev/next clicks land mid smooth-scroll, where the live scroll
     offset still reports the group being left; navigating from the pending
     target instead keeps every click advancing one group. The target clears
     once scrolling settles (covers manual swipes too). */
  function navBaseIndex(state) {
    return typeof state.target === 'number' ? state.target : currentGroupIndex(state);
  }

  function scheduleTargetClear(state) {
    if (state.settleTimer) window.clearTimeout(state.settleTimer);
    state.settleTimer = window.setTimeout(function () {
      state.settleTimer = null;
      state.target = null;
    }, 150);
  }

  function updateNav(state) {
    var wall = state.wall;
    var groups = groupsFor(state.root);
    var hasOverflow = !!wall && groups.length > 0 && wall.scrollWidth > wall.clientWidth + 1;
    var atStart = !wall || wall.scrollLeft <= 1;
    var atEnd = !wall || wall.scrollLeft >= wall.scrollWidth - wall.clientWidth - 1;

    if (state.controls) state.controls.hidden = !hasOverflow;
    setButton(state.prev, state.next, !hasOverflow || atStart);
    setButton(state.next, state.prev, !hasOverflow || atEnd);

    var current = groups.length ? currentGroupIndex(state) + 1 : 0;
    if (state.status) {
      state.status.textContent = hasOverflow ? 'Image group ' + current + ' of ' + groups.length : '';
    }

    state.root.dataset.c31Ready = 'true';
    state.root.dataset.c31ActiveLayout = layoutFor(state.root);
    state.root.dataset.c31CurrentGroup = String(current);
    state.root.dataset.c31GroupCount = String(groups.length);
  }

  function scheduleNavUpdate(state) {
    if (state.navFrame) return;
    state.navFrame = window.requestAnimationFrame(function () {
      state.navFrame = null;
      updateNav(state);
    });
  }

  /* ---------------------------------------------------------------- */

  function scheduleResize(state) {
    if (state.resizeFrame) return;
    state.resizeFrame = window.requestAnimationFrame(function () {
      state.resizeFrame = null;
      render(state);
    });
  }

  function setup(root) {
    var existing = states.get(root);
    if (existing) {
      if (existing.cycle) {
        scheduleNavUpdate(existing);
      } else {
        render(existing);
      }
      return;
    }

    var controls = root.querySelector('[data-c31-controls]');
    var prev = root.querySelector('[data-c31-prev]');
    var next = root.querySelector('[data-c31-next]');
    var status = root.querySelector('[data-c31-status]');

    var state = {
      root: root,
      controls: controls,
      prev: prev,
      next: next,
      status: status,
      cycle: isGroupCycle(root),
      wall: root.querySelector('[data-c31-wall]'),
      track: root.querySelector('[data-c31-track]'),
      page: 0,
      size: groupSize(root),
      resizeFrame: null,
      navFrame: null,
      target: null,
      settleTimer: null
    };

    if (state.cycle) {
      state.onPrev = function () {
        goToGroup(state, navBaseIndex(state) - 1);
      };

      state.onNext = function () {
        goToGroup(state, navBaseIndex(state) + 1);
      };

      state.onScroll = function () {
        scheduleNavUpdate(state);
        scheduleTargetClear(state);
      };

      state.onResize = function () {
        state.target = null;
        scheduleNavUpdate(state);
      };

      if (state.wall) {
        state.wall.addEventListener('scroll', state.onScroll, { passive: true });
        state.wall.tabIndex = 0;
        state.wall.setAttribute('role', 'region');
        state.wall.setAttribute('aria-label', 'Product detail image gallery');
      }

      wrapGroups(root);
      updateNav(state);
    } else {
      state.onPrev = function () {
        state.page = Math.max(0, state.page - 1);
        render(state);
      };

      state.onNext = function () {
        state.page += 1;
        render(state);
      };

      state.onResize = function () {
        scheduleResize(state);
      };
    }

    if (prev) prev.addEventListener('click', state.onPrev);
    if (next) next.addEventListener('click', state.onNext);
    window.addEventListener('resize', state.onResize, { passive: true });

    states.set(root, state);
    root._c31GalleryTeardown = function () {
      teardown(root);
    };

    if (!state.cycle) render(state);
  }

  function teardown(root) {
    var state = states.get(root);
    if (!state) return;

    if (state.prev) state.prev.removeEventListener('click', state.onPrev);
    if (state.next) state.next.removeEventListener('click', state.onNext);
    window.removeEventListener('resize', state.onResize);
    if (state.resizeFrame) window.cancelAnimationFrame(state.resizeFrame);
    if (state.navFrame) window.cancelAnimationFrame(state.navFrame);
    if (state.settleTimer) window.clearTimeout(state.settleTimer);

    if (state.cycle) {
      if (state.wall) {
        state.wall.removeEventListener('scroll', state.onScroll);
        state.wall.removeAttribute('tabindex');
        state.wall.removeAttribute('role');
        state.wall.removeAttribute('aria-label');
      }
      unwrapGroups(root);
    }

    var items = itemsFor(root);
    for (var i = 0; i < items.length; i += 1) {
      items[i].hidden = false;
      items[i].removeAttribute('aria-hidden');
      items[i].removeAttribute('data-c31-slot');
    }

    if (state.controls) state.controls.hidden = true;
    root.removeAttribute('data-c31-ready');
    root.removeAttribute('data-c31-active-layout');
    root.removeAttribute('data-c31-current-group');
    root.removeAttribute('data-c31-group-count');
    root._c31GalleryTeardown = null;
    states.delete(root);
  }

  function rootsFor(scope) {
    var base = scope && scope.querySelectorAll ? scope : document;
    var roots = [];

    if (base.matches && base.matches(ROOT_SELECTOR)) roots.push(base);

    var found = base.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < found.length; i += 1) roots.push(found[i]);

    return roots;
  }

  function init(scope) {
    var roots = rootsFor(scope);
    for (var i = 0; i < roots.length; i += 1) setup(roots[i]);
  }

  function selectedItemFrom(event) {
    var target = event && event.target;
    if (!target) return null;
    if (target.closest) {
      var closest = target.closest(ITEM_SELECTOR);
      if (closest) return closest;
    }
    if (target.querySelector) return target.querySelector(ITEM_SELECTOR);
    return null;
  }

  function onBlockSelect(event) {
    init(event && event.target);

    var item = selectedItemFrom(event);
    if (!item || !item.closest) return;

    var root = item.closest(ROOT_SELECTOR);
    if (!root) return;

    setup(root);

    var state = states.get(root);
    if (!state) return;

    if (state.cycle) {
      var group = item.closest(GROUP_SELECTOR);
      var index = groupsFor(root).indexOf(group);
      if (index > -1) goToGroup(state, index, 'auto');
      return;
    }

    var items = itemsFor(root);
    var itemIndex = items.indexOf(item);
    if (itemIndex > -1) render(state, itemIndex);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event && event.target);
  });

  document.addEventListener('shopify:block:select', onBlockSelect);

  document.addEventListener('shopify:section:unload', function (event) {
    var roots = rootsFor(event && event.target);
    for (var i = 0; i < roots.length; i += 1) teardown(roots[i]);
  });

  window[GLOBAL_KEY] = {
    init: init,
    teardown: teardown
  };
})();
